import React, {useState} from 'react';
import {registerDispatch} from '../../actions/util';
import {connect} from 'react-redux';
import {DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from 'reactstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlusCircle} from '@fortawesome/free-solid-svg-icons';
import {addMemberRegistrationAction, moveMemberAction} from '../../actions/member';
import {GradeLevelSelectorModal} from '../index';

const SearchMemberItems = ({
                             event,
                             member,
                             index,
                             registrationType,
                             isWalkInMember,
                             moveMemberAction,
                             addMemberRegistrationAction
                           }) => {

  const [isGradeLevelModalOpen, setIsGradeLevelModalOpen] = useState(false);
  const [pendingRegistration, setPendingRegistration] = useState(null);

  const handleRegistrationClick = (isPriority) => {
    setPendingRegistration({isPriority});
    setIsGradeLevelModalOpen(true);
  };

  const handleGradeLevelConfirm = (gradeLevel) => {
    if (pendingRegistration) {
      addMemberRegistrationAction(event.id, member.id, pendingRegistration.isPriority, isWalkInMember, gradeLevel);
      setPendingRegistration(null);
    }
  };

  return (
    <>
      <tr>
        <td id={'member' + index} className='cursor-pointer'>
          {member.frstname}
        </td>
        <td id={'member' + index} className='cursor-pointer'>
          {member.lastname}
        </td>
        <td>
          {member.fileno}
        </td>
        <td>
          {member.title}
        </td>
        <td>
          {member.sitecode}
        </td>
        <td>
          <UncontrolledDropdown style={{display: "inline"}}>
            <DropdownToggle id={"tooltip-site-delete" + index} caret outline color="primary">
              <FontAwesomeIcon icon={faPlusCircle}/>
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem className="text-primary cursor-pointer" onClick={() => {
                if (registrationType === "Move") {
                  moveMemberAction(event.id, member.id, false, isWalkInMember);
                } else {
                  handleRegistrationClick(false);
                }
              }}>
                {registrationType} member
              </DropdownItem>
              {registrationType === "Register" && <DropdownItem className="text-primary cursor-pointer" onClick={() => {
                handleRegistrationClick(true);
              }}>
                {registrationType} priority member
              </DropdownItem>
              }
            </DropdownMenu>
          </UncontrolledDropdown>
        </td>
      </tr>
      <GradeLevelSelectorModal
        isOpen={isGradeLevelModalOpen}
        toggle={() => setIsGradeLevelModalOpen(false)}
        onConfirm={handleGradeLevelConfirm}
      />
    </>
  );
};
const mapDispatchProps = dispatch => {
  registerDispatch(dispatch);
  return {
    addMemberRegistrationAction,
    moveMemberAction
  };
};

export default connect(
  undefined,
  mapDispatchProps
)(SearchMemberItems);
